import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

type DraftPermissions = {
  drafts: boolean;
  types: boolean;
  variables: boolean;
  bonds: boolean;
  witnesses: boolean;
};

@Component({
  selector: 'app-dashboard-drafts',
  templateUrl: './dashboard-drafts.component.html',
  styleUrls: ['./dashboard-drafts.component.scss'],
})
export class DashboardDraftsComponent implements OnInit {
  canView: DraftPermissions = {
    drafts: true,
    types: true,
    variables: true,
    bonds: true,
    witnesses: true,
  };

  activeTab: 'types' | 'variables' | 'models' | 'bonds' | 'witnesses' = 'types';

  constructor(
    private toast: ToastService,
    private router: Router,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.setPermissions();
    this.setBreadcrumb();
    if (
      !this.canView.drafts &&
      !this.canView.types &&
      !this.canView.variables &&
      !this.canView.bonds &&
      !this.canView.witnesses
    ) {
      this.toast.show(
        'error',
        'Aviso',
        'Você não tem permissão para acessar essa página.'
      );
      this.router.navigateByUrl('/app/dashboard');
    }
  }

  setBreadcrumb(): void {
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Minutas',
        url: '/app/drafts',
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }

  setPermissions() {
    const permissionArr = [
      'de_can_view_drafts',
      'de_can_view_types',
      'de_can_view_variables',
      'de_can_view_bonds',
      'de_can_view_witnesses',
    ];

    permissionArr.forEach((permission) => {
      const label = permission.split('_').slice(3).join('_');

      this.canView[`${label}`] = this.authService.verifyPermission([
        permission,
      ]);
    });

    // Definir a primeira tab disponível como ativa
    if (this.canView.types) {
      this.activeTab = 'types';
    } else if (this.canView.variables) {
      this.activeTab = 'variables';
    } else if (this.canView.drafts) {
      this.activeTab = 'models';
    } else if (this.canView.bonds) {
      this.activeTab = 'bonds';
    } else if (this.canView.witnesses) {
      this.activeTab = 'witnesses';
    }
  }

  onTabChange(tab: 'types' | 'variables' | 'models' | 'bonds' | 'witnesses') {
    this.activeTab = tab;
  }

  shouldShowCard(
    cardType: 'types' | 'variables' | 'models' | 'bonds' | 'witnesses'
  ): boolean {
    return (
      this.activeTab === cardType &&
      this.canView[cardType === 'models' ? 'drafts' : cardType]
    );
  }
}
